export enum Status {
  Upload = 'Upload',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
}

export enum StatusCategoryTab {
  Active = 'Active Applications',
  Inactive = 'Inactive Applications',
}

export enum ApplicationSortingField {
  DisplayId = 'displayId',
  CreatedAt = 'createdAt',
  LoanAmount = 'loan_amount',
  StatusName = 'status',
}

export enum ApplicationStatus {
  Active = 'Active',
  Pitched = 'Pitched',
  Purgatory = 'Purgatory',
  Processing = 'Processing',
  ReadyToSubmit = 'Ready to Submit',
  Underwriting = 'Underwriting',
  NeedMoreInfo = 'Need More Info',
  Compliance = 'Compliance',
  NMICompleted = 'NMI - COMPLETED',
  PendingFunding = 'Pending Funding',
  Approved = 'Funded',
  Rejected = 'Rejected',
}

export enum ApplicationRejectReason {
  LenderDecline = 'Lender Decline',
  DidNotFundLenderApproved = 'DNF - Lender Approved',
  TUD = 'TUD',
  AutoDeclinePlusCredit = 'Auto Decline + Credit',
  AutoDeclinePlusFrozenOrLocked = 'Auto Decline + Frozen / Locked',
  AutoDeclinePlusFraud = 'Auto Decline + FRAUD',
  Ineligible = 'Ineligible',
  Fraud = 'FRAUD',
  Credit = 'Credit',
  DTI = 'DTI',
  NotReadyToProceed = 'Not Ready to Proceed',
  NRC = 'NRC',
}

export enum ApplicationsTableStatus {
  Active = 'Active',
  Pitched = 'Pitched',
  Processing = 'Processing',
  Underwriting = 'Underwriting',
  Approved = 'Approved',
  PendingFunding = 'PendingFunding',
  Funded = 'Funded',
  Rejected = 'Rejected',
}

export enum ApplicationsTableColumnsTitle {
  ID = 'HFS ID',
  Borrower = 'Borrower',
  CoBorrower = 'Co-Borrower',
  ApplicationDate = 'Application Date',
  LoanAmount = 'Loan Amount',
  StatusName = 'Status',
  ActionNeeded = 'Action Needed',
  LoanDecision = 'Loan Decision',
}

export enum ApplicationsTableRejectReason {
  ConditionallyApproved = 'Conditionally Approved - Did Not Fund',
  UnableToQualify = 'Unable To Qualify',
  ApprovedDidNotFund = 'Approved - Did Not Fund',
  UnableToQualifyCredit = 'Unable To Qualify - Credit',
  UnableToQualifyFrozenOrLocked = 'Unable To Qualify - Credit is Frozen or Locked',
  UnableToQualifyIneligible = 'Unable To Qualify - Ineligible',
  UnableToQualifyDTI = 'Unable To Qualify - DTI',
  ConditionallyApprovedNRTP = 'Conditionally Approved - Not Ready to Proceed',
  ConditionallyApprovedADNR = 'Conditionally Approved - Applicant(s) Did Not Respond',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum DocumentName {
  ContractWorkOrder = 'contractWorkOrder',
}

export enum InactiveStatusTab {
  AllInactive = 'All Applications',
  Funded = 'Funded',
  WillNotFund = 'Will Not Fund',
}

export enum ApplicationsStatusCategory {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum ApplicationsInactiveStatus {
  All = 'All',
  Funded = 'Funded',
  Rejected = 'Rejected',
}
